export default __webpack_public_path__ + "79bdada85f166ea1682164c1dea6cf2a.jpg";